import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot } from 'firebase/firestore/lite';

import { ContentData, ContentType, TextContentData } from '../types/contentTypes';

const contentConverter: FirestoreDataConverter<ContentData> = {
  toFirestore(content: ContentData): DocumentData {
    return { ...transformDataToFirestoreData(content) };
  },

  fromFirestore(docSnap: QueryDocumentSnapshot): ContentData {
    return transformDataFromFirebaseData(docSnap);
  },
};

/**
 * Transform certain content data before storing to firestore. Adjust values of props that can not directly be stored in
 * firestore as is.
 * @private
 */
function transformDataToFirestoreData(content: ContentData): DocumentData {
  return content;
}

/**
 * Transform certain content data after loading from firestore. Pretty much reverses the process of transformToFirestoreData.
 * @private
 */
function transformDataFromFirebaseData(docSnap: QueryDocumentSnapshot<DocumentData>): ContentData {
  const content = { ...docSnap.data(), id: docSnap.id } as ContentData;
  switch (content.type) {
    case ContentType.Text:
      return replaceNewlineCharacters(content);
    default:
      return content;
  }
}

/**
 * Replaces \\n for \n in a text contents props' content. Firestore automatically turns
 * \n to \\n when retrieving from database so we need to manually reverse this.
 */
function replaceNewlineCharacters(content: TextContentData): TextContentData {
  const updatedContent = content.text.replaceAll('\\n', '\n');
  return { ...content, text: updatedContent };
}

export default contentConverter;
